import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Form, Skeleton , Row, Select, Typography, Space, Button, Flex, InputNumber } from 'antd';
import {getById, } from '../../../../apis/MovimientoEmpleadoApi';
import {getList as getPeriodos, getDetailsById as getDetailsByPeriodId} from '../../../../apis/PeriodosApi';
import {getEmpleadosByPeriodId, getEmpleados} from '../../../../apis/OdooApi';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import _ from 'lodash';
const { Text, Link } = Typography;

const { Option } = Select;
const App = forwardRef(function AnioPeriodo({onOk, onChangeEmpleado, onCancel, header, form, object, values, disabledForm}, ref) {
    const [empleadoCookie, setEmpleadoCookie] = useCookies("empleado_id");
    const [ID, setID] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [initialValues, setInitialValues] = useState(values);
    const [empleados, setEmpleados] = useState([]);
    const [empleado, setEmpleado] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);
    //1- Sustituir 2- Sumar 3- No Sustituir, Default 1
    const [clases, setClases] = useState([
        {value: "1", text:'Sustituir'},
        {value: "2", text:'Sumar'},
        {value: "3", text:'No Sustituir'},
    ]);
    const conceptoRef = React.createRef();
    const effectRan = useRef(false);
    useEffect(() => {
        (async () => {
            await getEmpleadosOdoo(4);
            if(!header){return;}
            if(header?.periodo_id > 0){
                await getEmpleadosOdoo(header.periodo_id);
            }

            var _initialValues = {...header};
            if(header?.period_id > 0){
                _initialValues.period_id = header.period_id;
            }
            if(header?.num_periodo > 0){
                _initialValues.num_periodo = header.num_periodo;
            }
            if(header?.anio > 0){
                _initialValues.anio = header.anio;
            }
            if(header?.odoo_empleado_id > 0){
                _initialValues.odoo_empleado_id = header.odoo_empleado_id;
            }
            form.setFieldsValue(_initialValues);
        })();
    }, [header]);

    useEffect(() => {
        (async () => {
            if(object?.id > 0){
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            if(tipoPeriodoSelected?.value > 0){
                await getDetailsPeriodo(tipoPeriodoSelected.value);                    
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);

    useEffect(() => {
        (async () => {
            if(!header){return;}

            var _initialValues = {...header};
            if(header?.period_id > 0){
                _initialValues.period_id = header.period_id;
            }
            if(header?.num_periodo > 0){
                _initialValues.num_periodo = header.num_periodo;
            }
            if(header?.anio > 0){
                _initialValues.anio = header.anio;
            }
            if(header?.odoo_empleado_id > 0){
                _initialValues.odoo_empleado_id = header.odoo_empleado_id;
                debugger;
                await onChangeEmpleadoSelect(header.odoo_empleado_id)
            }
            form.setFieldsValue(_initialValues);
        })();
    }, [empleados]);

    const refreshData = async (id)=> {
        const response = await getById(id);
        if(response.ok){
            let item = response.payload;
            setInitialValues(item);
            form.setFieldsValue(item);
        }
    }

    const getEmpleadosOdoo = async (period_id)=>{
        const response = await getEmpleados();
        if(response.ok){
            let items = response.payload;
            setEmpleados(items);
            if(header?.odoo_empleado_id > 0){
                await onChangeEmpleado(empleadoCookie);
            }
        }
    }

    const getDetailsPeriodo = async (id)=>{
        let detailsResponse = await getDetailsByPeriodId(id);
        if(detailsResponse.ok){
            let item = detailsResponse.payload;
            setDetailsPeriodo(item);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async ({}) => {
        if(onCancel){
            await onCancel();
        }
    }

    const onFinish = async ()=> {
        setLoading(true);
        var values = form.getFieldsValue();
        const payload = {
            ...values,
            anio: values.anio ?? null,  // Agrega `anio` si no existe
            odoo_empleado_id: values.odoo_empleado_id ?? null, // Agrega `odoo_empleado_id` si no existe
        };
    
        await onOk(payload);
        setLoading(false);
    }

    const onChangeEmpleadoSelect = async (value)=>{
        const empleado = empleados.find(x=>x.value == value)
        setEmpleado(empleado);
        setEmpleadoCookie(empleado);
        await onChangeEmpleado(value);
    }

    const onChangeAnio = async (value)=>{
    }


    return (
        <>
            <Form
                layout="vertical" 
                form={form} 
                requiredMark 
                autoComplete="off"
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="odoo_empleado_id"
                            label="Empleado"
                            rules={[
                            {
                                required: true,
                                message: 'Selecciona un empleado',
                            },
                            ]}
                        >
                                <Select placeholder="Por favor selecciona un empleado" onChange={onChangeEmpleadoSelect}>
                                {
                                    empleados.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                        name="anio"
                        label="Año"
                        rules={[
                        {
                            required: false,
                            message: '',
                        },
                        ]}
                    >
                        <InputNumber placeholder="Por favor agrega un año" onBlur={onChangeAnio}/>
                    </Form.Item>
                    </Col>
                    {
                        empleado && 
                        <Col md={{span: 16}} sm={{span: 16}} xs={{span: 24}}>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>Salario Diario <b><Currency value={empleado.nomina_daily_salary} /></b></Text>
                                    <Text keyboard>Salario Integrado <b><Currency value={empleado.nomina_integrated_salary} /></b></Text>
                                </Space>
                            </Row>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>Registro Patronal <b>{empleado.nomina_employer_registration_key}</b></Text>
                                    <Text keyboard>Fecha de Ingreso <b>{empleado.nomina_entry_date}</b></Text>
                                    {
                                        empleado.nomina_leaving_date && <Text keyboard>Fecha de Baja <b>{empleado.nomina_leaving_date}</b></Text>
                                    }
                                </Space>
                            </Row>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>{empleado.work_email}</Text>
                                    <Text keyboard>{empleado.job_title}</Text>
                                </Space>
                            </Row>
                        </Col>
                    }
                </Row>
                <Form.Item>
                    <Space>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            {loading ? 'Obteniendo': 'Obtener'}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default App;
